import styled from 'styled-components'
import { IcoMoon } from '@usap/uicomponents'

export const Wrapper = styled.div<{ forCart?: boolean, forCheckout?: boolean, forAccount?: boolean, forPlp?: boolean}>`
  display: flex;
  position: relative;
  margin: 0 ${props => (props?.forCheckout || props?.forAccount ? '10px' : '')};
  align-items: ${props => (props?.forCheckout ? 'end' : 'center')};

  @media (min-width: 993px) {
    margin: 0 ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? '10px' : '')};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const Message = styled.p<{
  showPointer: boolean,
  forCart?: boolean,
  forCheckout?: boolean,
  forPlp?: boolean,
  forAccount?: boolean,
}>`
  display: inline-block;
  font-size: 12px;
  font-weight: ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 600 : 400)};
  line-height: 16px;
  justify-content: center;
  align-items: center;
  margin: 0;
  color: ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 'rgb(5, 98, 155)' : '#333')};
  text-decoration: ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 'underline' : 'none')};
  ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 'width: 84px;' : '')}

  @media (min-width: 993px) {
    ${props => (props?.forCart || props?.forPlp ? '' : 'font-size: 14px')};
    ${props => (props?.forCart || props?.forPlp ? '' : 'line-height: 20px')};
  }

  @media (max-width: 369px) {
    ${props => (!props?.forCart && !props?.forCheckout && !props?.forAccount ? 'width: 160px;' : '')}
  }

  @media (max-width: 400px) {
    ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 'width: 84px;' : '')};
    ${props => (props?.forPlp ? 'width: 160px;' : '')}
  }

  & .info {
    display: inline-block;
    ${props => (props?.forCart || props?.forCheckout || props?.forAccount ? 'margin-left: -16px;' : '')}
  }

  & .info:after {
    display: ${props => (props?.showPointer ? 'block' : 'none')};
    background: transparent;
    color: #fff;
    content: "▼";
    position: absolute;
    bottom: 22px;
    z-index: 12;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.32);
    font-size: 28px;
    line-height: 23px;
  }
`

export const Info = styled(IcoMoon)`
  margin-left: 4px;
  vertical-align: middle;
`
